import { createSelector } from 'reselect';

const substate = (state) => state.payment;

export const selectSendPaymentLinkDto = () =>
    createSelector(substate, (contextState) => contextState.sendPaymentLinkDto);
